import { View } from 'react-native'
import React from 'react'
import { Slider } from '@miblanchard/react-native-slider';
import { Theme, ThemedView } from '@app/theme';
import { useTheme } from '@shopify/restyle';
import SliderThumbIcon from '@app/assets/svg/SliderThumbIcon';



const RangeSlider = ({ min, max, value, onChange, onComplete }: { min: number, max: number, value: number, onChange: (value: number) => void, onComplete: (value: number) => void }) => {

  const { colors } = useTheme<Theme>()

  return (
    <View>
      <Slider
        minimumValue={min}
        maximumValue={max}
        trackStyle={{ backgroundColor: colors['bg-surface-emphasis-primary'], height: 6, borderRadius: 6 }}
        minimumTrackTintColor={colors['bg-fill-emphasis-primary-2']}
        value={value}
        step={max < 25000 ? 100 : 1000}
        onValueChange={(value) => {
          onChange(value[0])
        }}
        onSlidingComplete={(value) => {
          onComplete(value[0])
        }}
        renderThumbComponent={() => {
          return (
            <ThemedView alignItems='center' justifyContent='center' height={32} width={32} bg='white' borderColor='bg-fill-emphasis-primary-2' borderWidth={4} borderRadius='full' >
              <SliderThumbIcon color={colors['bg-fill-emphasis-primary-2']} />
            </ThemedView>
          )
        }}
      />
    </View>
  )
}

export default React.memo(RangeSlider)
